import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import DefaultViewWithoutTitle from '../../Custom/DefaultViewWithoutTitle';

/**
 * View for a Topic's own sub-pages (e.g. "Publications"/"Downloads" under a
 * research Topic like Deep Learning) - plain Documents, given this layout
 * via their `layout` field so they get the same view-header look as the
 * rest of the site instead of the default Document view. The tab bar back
 * to the Topic and its siblings is a "Section Tabs" listing block placed as
 * the first block on the page (see SectionTabsListingView) - not rendered
 * here, so it stays editable/reorderable like any other block.
 */
const TopicSubpageView = (props) => {
  const { content } = props;

  return (
    <Container id="view-wrapper" className="TopicView TopicSubpageView">
      <div className="view-header">
        <h2 className="view-header__title">{content.title || content.id}</h2>
        {/* No description here. `description` is a listing field - the one
            line that goes on a card and into a search result - and repeating
            it as the first paragraph of the page it summarises says the same
            thing twice. The full view has its own content. */}
        <div className="view-header__divider" />
      </div>

      <DefaultViewWithoutTitle {...props} />
    </Container>
  );
};

TopicSubpageView.propTypes = {
  content: PropTypes.shape({
    '@id': PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default TopicSubpageView;
